import { useSearchParams } from 'react-router-dom';

/**
 * Returns the current school-cycle year.
 * Cycle 2025 runs Aug 2025 – Jul 2026, so:
 *   - month >= August (7)  → calendar year
 *   - month < August       → calendar year - 1
 */
function getCycleYear() {
  const now = new Date();
  return now.getMonth() >= 7 ? now.getFullYear() : now.getFullYear() - 1;
}

/**
 * Reads and updates a year/cycle URL query parameter.
 *
 * @param {string} paramKey - The query param name to read/write (default: 'ciclo').
 *                            Reads the specified key; falls back to the alternate key ('year' or 'ciclo').
 * @returns {[number, function, number]} [year, onChange, currentCycleYear]
 */
function useYearParam(paramKey = 'ciclo') {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentYear = getCycleYear();
  const fallbackKey = paramKey === 'year' ? 'ciclo' : 'year';
  const parsed = parseInt(searchParams.get(paramKey) || searchParams.get(fallbackKey));
  const year = isNaN(parsed) ? currentYear : parsed;

  function onChange(e) {
    const y = parseInt(e.target.value);
    if (!isNaN(y)) {
      setSearchParams({ [paramKey]: y.toString() });
    }
  }

  return [year, onChange, currentYear];
}

export { getCycleYear };

export default useYearParam;
